import React from 'react';
import { ShoppingBagIcon } from 'lucide-react';
interface AddToCartButtonProps {
  disabled?: boolean;
  onClick: () => void;
}
export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  disabled = false,
  onClick
}) => {
  return <button type="button" className={`
        mt-8 flex w-full items-center justify-center rounded-md px-6 py-3 text-base font-medium text-white
        focus:outline-none focus:ring-2 focus:ring-fuchsia-500 focus:ring-offset-2
        ${disabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-fuchsia-600 hover:bg-fuchsia-700 transition-colors duration-200'}
      `} disabled={disabled} onClick={onClick} data-id="element-8">
      <ShoppingBagIcon className="mr-2 h-5 w-5" aria-hidden="true" data-id="element-9" />
      Add to bag
    </button>;
};